module.exports = __webpack_public_path__ + "img/1539618428.65fe98a2.jpg";